<template>
  <card class="card-stats" :show-footer-line="true">
    <div class="row">
      <div class="col-5" v-if="$slots.icon || icon">
        <div class="info-icon text-center" :class="`icon-${type}`">
          <slot name="icon">
            <i :class="icon"></i>
          </slot>
        </div>
      </div>

      <div class="col-7" v-if="$slots.content || title || subTitle">
        <div class="numbers">
          <slot>
            <p v-if="subTitle" class="card-category">{{ subTitle }}</p>
            <h3 v-if="title" class="card-title">
              {{ title }}
            </h3>
          </slot>
        </div>
      </div>
    </div>

    <div class="stats" slot="footer">
      <slot name="footer" v-if="$slots.footer"></slot>

      <div
        v-if="Object.keys(filteredMap).length > 0"
        class="breakdown-container"
      >
        <div
          v-for="(value, key) in filteredMap"
          :key="key"
          class="breakdown-item"
        >
          <span class="breakdown-key">{{ formatKey(key) }}</span>
          <span class="breakdown-colon">:</span>
          <span class="breakdown-value"><strong>{{ value }}</strong></span>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import Card from './Card.vue';

export default {
  name: 'StatsCardBreakdown',
  components: {
    Card,
  },
  props: {
    type: {
      type: String,
      default: 'primary',
    },
    icon: String,
    title: String,
    subTitle: String,
    dataMap: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    filteredMap() {
      const result = { ...this.dataMap };
      // The 'total' key is excluded as it's intended for the main title
      delete result.total;
      return result;
    },
  },
  methods: {
    formatKey(key) {
      // Replaces underscores with spaces for display
      return key.replace(/_/g, ' ');
    },
  },
};
</script>

<style scoped>
.card-stats .stats {
  color: var(--text-primary-color);
}

.breakdown-container {
  display: grid;
  /* This single line creates a responsive, wrapping column layout */
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px 16px; /* row-gap and column-gap */
  margin-top: 8px;
  width: 100%;
}

.breakdown-item {
  display: grid;
  /* Aligns the key, colon, and value within each item */
  grid-template-columns: 1fr auto 1fr;
  font-size: 13px;
  align-items: baseline;
  gap: 4px;
}

.breakdown-key {
  text-transform: capitalize;
  text-align: left;
  white-space: normal;
  word-break: break-word;
}

.breakdown-colon {
  text-align: center;
}

.breakdown-value {
  font-weight: 500;
  text-align: left;
}
</style>